module.exports = __webpack_public_path__ + "img/2.0604d411.png";